<template>
    <div class="canvas">
        <canvas id="canvas" @touchstart="touchstart" @touchend="touchend" @touchmove="touchmove"></canvas>
        <div class="btnList">
            <ul>
                <li @click="stepBack" :style="AllArr.length == 0?'color:#9d9d9d':''">
                    <i class="layui-icon">&#xe603;</i>
                    <p>撤销</p>
                </li>
                <li @click="clear">
                    <i class="layui-icon">&#xe640;</i>
                    <p>清空</p>
                </li>
                <li @click="nexSetp" :style="trash.length == 0?'color:#9d9d9d':''">
                    <i class="layui-icon">&#xe602;</i>
                    <p>恢复</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                ctx: {},
                cDom:{},
                point: {
                    x: 0,
                    y: 0
                },
                trash:[],
                tempArr:[],
                AllArr:[],
                mp:5,
                pencil:1.5,
                pencilColor:'#a8a8a8'
            }
        },
        watch:{
            tempArr(e){
                this.$forceUpdate();
            },
            trash(e){
                this.$forceUpdate();
            }
        },
        mounted() {
            let That = this;
            That.init();
        },
        methods: {
            // 返回上一步
            stepBack(event){
                let length = this.AllArr.length;
                if(length > 0){
                    this.clearCanvas();
                    this.trash.push(this.AllArr[length - 1]);
                    this.AllArr = this.RemoveArray(this.AllArr,length - 1);
                    this.DataDraw(this.AllArr);
                }
                event.stopPropagation();
            },

            // 恢复
            nexSetp(event){
                let length = this.trash.length;
                if(length > 0){
                    this.clearCanvas();
                    this.AllArr.push(this.trash[length - 1]);
                    this.trash = this.RemoveArray(this.trash,length - 1);
                    this.DataDraw(this.AllArr);
                }
                event.stopPropagation();
            },
            clear(event){
                this.tempArr = [];
                this.AllArr = [];
                this.clearCanvas();
                event.stopPropagation();
            },

            //canvas 初始化
            init() {
                let That = this;
                That.cDom = $('#canvas')[0];
                let width = $(window).width();
                let height = $(window).height();
                That.cDom.width = width * That.mp;
                That.cDom.height = height * That.mp;
                That.cDom.style.width = width + 'px';
                That.cDom.style.height = height + 'px';
                That.ctx = That.cDom.getContext('2d');
                That.ctx.strokeStyle = That.pencilColor;
                That.ctx.lineWidth = That.pencil;
                That.ctx.lineCap="round";
                That.ctx.lineJoin="round";
                That.ctx.scale(That.mp,That.mp);
            },
            //获取相对坐标
            absolutePoint(event) {
                const touch = event.targetTouches[0];
                const react = this.cDom.getBoundingClientRect();
                this.point = { x: touch.pageX - react.left, y: touch.pageY - react.top }
            },
            //绘制
            draw(event) {
                this.$forceUpdate();
                this.tempArr.push({
                    x:this.point.x,
                    y:this.point.y
                });
                this.ctx.lineTo(this.point.x, this.point.y);
                this.ctx.stroke();
            },
            //开始触摸
            touchstart(event) {
                this.absolutePoint(event);
                this.ctx.moveTo(this.point.x, this.point.y);
            },
            //触摸结束
            touchend(event) {
                this.AllArr.push(this.tempArr);
                this.tempArr=[];
            },
            //触摸移动
            touchmove(event) {
                this.absolutePoint(event);
                this.draw(event);
                event.stopPropagation();
                event.preventDefault();
            },

            initDraw(){
                this.DataDraw(this.AllArr);
            },

            // 清除画布
            clearCanvas(){
                let That = this;
                That.cDom.height = That.cDom.height
                That.init();
            },

            // 用三维数组数据直接画图——还原画图
            DataDraw(arr){
                let That = this;
                for(let i=0;i<arr.length;i++){

                    for(let n=0;n<arr[i].length;n++){
                        if(n == 0){
                            That.ctx.moveTo(arr[i][n].x , arr[i][n].y);
                        }
                        That.ctx.lineTo(arr[i][n].x, arr[i][n].y);
                        That.ctx.stroke();
                    }
                }
            },


            // 移除数组指定下标成员
            RemoveArray(arr,index){
                let NewArr = [];
                let length = arr.length;
                if(length > 0){
                    for(let i=0;i<arr.length;i++){
                        if(i != index){
                            NewArr.push(arr[i])
                        }

                    }
                }
                return NewArr;
            }
        }
    }
</script>

<style scoped>
    .canvas{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
    }
    .canvas canvas{
        width: 100%;
        height: 100%;
    }
    .btnList{
        width: 7rem;
        height: 1rem;
        line-height: 1rem;
        position: fixed;
        bottom: 0;
        left: calc(0.5rem / 2);
        z-index: 99;
    }
    .btnList ul{
        text-align: center;
    }
    .btnList ul li{
        display: inline-block;
        line-height: 0.4rem;
        padding: 0 0.5rem;
        text-align: center;
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/module/canvasDraw/canvasDraw.vue